import { useRef, useState } from 'react'
import { Popover } from '@mui/material'
import {useTranslation} from "react-i18next";

interface HelpMenuProps {
  onStartTour: () => void
  onOpenFaq: () => void
  onOpenReleaseNotes: () => void
  /**
   * The guided tour is gated to the `expanded` layout: below `lg` half its anchors
   * live inside a closed drawer or the header overflow menu, so it cannot run.
   * The entry is suppressed rather than disabled: a permanently greyed-out item
   * invites support tickets asking why.
   */
  showTour?: boolean
}

export function HelpMenu({ onStartTour, onOpenFaq, onOpenReleaseNotes, showTour = true }: HelpMenuProps) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const anchorRef = useRef<HTMLAnchorElement>(null)

  const close = () => setOpen(false)

  return (
    <>
      <a
        ref={anchorRef}
        href="#"
        onClick={(e) => { e.preventDefault(); setOpen((o) => !o) }}
        aria-haspopup="true"
        aria-expanded={open}
        data-tour="help-menu"
      >
          {t('help.helpMenu')} 
      </a>

      <Popover
        open={open}
        anchorEl={anchorRef.current}
        onClose={close}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        slotProps={{
          paper: {
            className: 'help-menu-paper',
            sx: { mt: '4px', borderRadius: '6px', boxShadow: 'var(--shadow-menu-soft)' },
          },
        }}
      >
        <div className="help-menu">
          <a
            className="help-menu-item"
            href={t('links.support')}
            target="_blank"
            rel="noopener noreferrer"
            onClick={close}
          >
              {t('help.isacaSupport')}
          </a>
          {showTour && (
            <button className="help-menu-item" onClick={() => { close(); onStartTour() }}>
                {t('help.guidedTour')}
            </button>
          )}
          <button className="help-menu-item" onClick={() => { close(); onOpenFaq() }}>
              {t('help.faqs')}
          </button>
          <button className="help-menu-item" onClick={() => { close(); onOpenReleaseNotes() }}>
              {t('help.releaseNotes')}
          </button>
        </div>
      </Popover>
    </>
  )
}
